/**
 * Универсальный сервис трекинга конверсий
 * Поддерживает: Яндекс.Метрика, Google Analytics
 * Заглушки для будущего: Facebook Pixel, Google Ads, TikTok Pixel
 *
 * Добавление нового трекера:
 * 1. Добавить объект трекера в массив trackers с методами trackEvent(eventName, params)
 * 2. Инициализировать скрипт трекера в index.html
 */

// ============================================
// ЯНДЕКС.МЕТРИКА
// ============================================
const yandexMetrika = {
  trackEvent(eventName, params = null) {
    if (typeof window === 'undefined' || typeof window.ym !== 'function') {
      return
    }
    if (params && typeof params === 'object') {
      window.ym(104258304, 'reachGoal', eventName, params)
    } else {
      window.ym(104258304, 'reachGoal', eventName)
    }
  },
}

// ============================================
// GOOGLE ANALYTICS (gtag)
// ============================================
const googleAnalytics = {
  trackEvent(eventName, params = null) {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
      return
    }
    if (params && typeof params === 'object') {
      window.gtag('event', eventName, params)
    } else {
      window.gtag('event', eventName)
    }
  },
}

// ============================================
// ЗАГЛУШКИ ДЛЯ БУДУЩИХ ПИКСЕЛЕЙ
// ============================================

// Facebook Pixel — раскомментировать после установки fbq
// const facebookPixel = {
//   trackEvent(eventName, params = null) {
//     if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
//       return
//     }
//     window.fbq('trackCustom', eventName, params || {})
//   },
// }

// Google Ads — раскомментировать после установки gtag/google_ads
// const googleAds = {
//   trackEvent(eventName, params = null) {
//     if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
//       return
//     }
//     window.gtag('event', 'conversion', { send_to: 'AW-XXX', ...params })
//   },
// }

// TikTok Pixel — раскомментировать после установки ttq
// const tiktokPixel = {
//   trackEvent(eventName, params = null) {
//     if (typeof window === 'undefined' || typeof window.ttq?.track !== 'function') {
//       return
//     }
//     window.ttq.track(eventName, params || {})
//   },
// }

// ============================================
// РЕЕСТР АКТИВНЫХ ТРЕКЕРОВ
// ============================================
const trackers = [
  yandexMetrika,
  googleAnalytics,
  // facebookPixel,  // ← раскомментировать при активации
  // googleAds,      // ← раскомментировать при активации
  // tiktokPixel,    // ← раскомментировать при активации
]

/**
 * Отправить событие во все активные трекеры
 * @param {string} eventName — название события (например 'pwa_install')
 * @param {object|null} params — дополнительные параметры
 */
export const trackEvent = (eventName, params = null) => {
  if (!eventName || typeof eventName !== 'string') {
    return
  }
  trackers.forEach((tracker, index) => {
    try {
      tracker.trackEvent(eventName, params)
    } catch (error) {
      console.warn(`⚠️ Ошибка трекинга в трекере #${index + 1}:`, error)
    }
  })
}

// ============================================
// ГОТОВЫЕ СЕМАНТИЧЕСКИЕ СОБЫТИЯ PWA
// ============================================

/**
 * Отправить конверсию "Установка PWA"
 * Вызывается при событии appinstalled
 */
export const trackPWAInstall = () => {
  trackEvent('pwa_install', {
    event_category: 'pwa',
    event_label: 'install',
  })
}

/**
 * Отправить конверсию "Первый запуск из installed PWA"
 * Вызывается при первом открытии в display-mode: standalone
 */
export const trackPWALaunch = () => {
  trackEvent('pwa_first_launch', {
    event_category: 'pwa',
    event_label: 'first_launch',
  })
}

/**
 * Отправить конверсию "Показ промпта установки"
 * Вызывается при beforeinstallprompt
 */
export const trackPWAPromptShown = () => {
  trackEvent('pwa_prompt_shown', {
    event_category: 'pwa',
    event_label: 'prompt_shown',
  })
}

/**
 * Отправить конверсию "Клик по кнопке установки"
 * Вызывается при клике на кнопку установки на /install
 */
export const trackPWAInstallClick = () => {
  trackEvent('pwa_install_click', {
    event_category: 'pwa',
    event_label: 'install_click',
  })
}

/**
 * Отправить конверсию "Отклонение установки"
 * Вызывается при outcome === 'dismissed'
 */
export const trackPWAInstallDismissed = () => {
  trackEvent('pwa_install_dismissed', {
    event_category: 'pwa',
    event_label: 'install_dismissed',
  })
}
